import { render, staticRenderFns } from "./IconMenu.vue?vue&type=template&id=6845287d&"
import script from "./IconMenu.vue?vue&type=script&lang=ts&"
export * from "./IconMenu.vue?vue&type=script&lang=ts&"
import style0 from "./IconMenu.vue?vue&type=style&index=0&id=6845287d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports